import { render, staticRenderFns } from "./Neoprene.vue?vue&type=template&id=d1f3e642&"
import script from "./Neoprene.vue?vue&type=script&lang=js&"
export * from "./Neoprene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports